import { refreshDynamicDataCache, createSignal, clearCachedPages } from '@avensia/excite';
import { setCustomerTypeOnCart } from './cart';
import { customerTypeObservable } from './customer-types';

export const [loginEvent] = createSignal();
export const [logoutEvent] = createSignal();
export const [registrationEvent] = createSignal();

function clearCachesOnLoginAndLogut() {
  clearCachedPages();
  refreshDynamicDataCache();
}

if (__BROWSER__) {
  loginEvent.on(() => clearCachesOnLoginAndLogut());
  logoutEvent.on(() => clearCachesOnLoginAndLogut());
  registrationEvent.on(() => clearCachesOnLoginAndLogut());
  customerTypeObservable.on((customerType: Excite.Commercetools.CustomerType | undefined) => {
    if (customerType) {
      setCustomerTypeOnCart(customerType);
    }
  });
}
